import { apiClient } from "@/src/api/apiClient";
import { CATEGORY_ENDPOINTS } from "@/src/api/endpoints";
import { normalizeCategoryChildren } from "@/src/services/assetCategoryFieldsService";
import type { CategoryChild } from "@/src/types/category.types";

export const categoryService = {
  async listAllChildren(): Promise<CategoryChild[]> {
    const categories = await apiClient.get<CategoryChild[]>(CATEGORY_ENDPOINTS.CHILDREN_LIST_ALL);
    return normalizeCategoryChildren(categories);
  },
};
